
<template>
  <b-modal @show="show" static id="modal-detail-record" centered title="Mensajes" hide-footer title-class="text-left title-modal-detail-record" modal-class="modal-detail-record" body-class="modal-body-record" size="xl">
    <template #modal-header>
      <p class="m-0 d-flex">Mensajes
        <filter-message :filterDefault="filterMessage" @filterMessage="(value) => filterMessage = value"></filter-message>
      </p>
      <b-button variant="link" class="p-0" @click="closeModal"><icons :icon="'ExpandArrowsInverseIcon'" :size="sizeIcon" ></icons></b-button>
    </template>
    <div class="modal--messages--expanded">
      <b-card class="modal--record-card">
        <body-detail-record v-if="showMessages"  :messages="arrayMessages" :ticket="ticket" :masterData="masterData" @updateTicket="updateTicket" :isTheModal="true"></body-detail-record>
      </b-card>
      <answer-management :masterData="masterData" :ticket="ticket" @updateTicket="updateTicket"></answer-management>
    </div>
  </b-modal>
</template>
<script>
import Icons from '@/Icons/Icons.vue'
import BodyDetailRecord from '@/views/modules/tickets/components/Detail/Message/BodyDetailRecord.vue'
import AnswerManagement from '@/views/modules/tickets/components/Detail/Answers/AnswerManage.vue'
import filterMessage from '@/views/modules/tickets/components/Detail/Message/FilterMessage.vue'
import {
  BIcon,
  BIconFilter
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
export default {
  props: ['ticket', 'masterData'],
  components: {BIcon, BIconFilter, Icons, BodyDetailRecord, AnswerManagement, filterMessage},
  data() {
    return {
      filterMessage: 'all',
      sizeIcon: {
        width: '20px',
        height: '20px'
      },
      showMessages: false
    }
  },
  computed: {
    arrayMessages() {
      return this.filterMessage !== '' && this.filterMessage !== 'all' ? this.ticket?.management_record.filter(el =>
        this.filterMessage === 'center' ? el.align === 'center' : el.align !== 'center'
      ) : this.ticket?.management_record ?? []
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-detail-record')
      this.showMessages = false
    },
    updateTicket() {
      this.$emit('updateTicket', true)
    },
    show() {
      this.showMessages = true
    }
  }
}
</script>
<style lang="scss">
  .modal--messages--expanded {
    max-height: 74vh;
    overflow: scroll;
  }
</style>
